import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, formatMessage } from 'translate';

import StyledHowItWorks from './styles/HowItWorks.styles';

import ReferralLinkIcon from '../../../../icons/pay-it-forward/referal_link.svg';
import EqualBg from '../../../../icons/pay-it-forward/equal_3x_desktop.svg';
import CloseIcon from '../../../../icons/wallet/close-white.svg';
// import BackIcon from '../../../../icons/wallet/back-white.svg';

const KeywordsMessages = ({
  referrals: { id: 'main.my_referrals' },
  watchOut: { id: 'campaign_pay_it_forward.watch_out' },
});

const HowItWorks = ({
  className = '',
  onClose,
  isMobile,
  // onBack,
  bgImg = EqualBg,
}) => (
  <StyledHowItWorks className={className} isMobile={isMobile}>
    <div className="how-it-work-bg">
      <img className="main-img" src={bgImg} alt="equal_3x_desktop.svg" />
      <p className="title">
        <FormattedMessage id="main.how_it_works" />
      </p>
      <img className="main-icon" src={ReferralLinkIcon} alt="referal_link.svg" />
    </div>
    <button className="action-close" onClick={onClose}>
      <img src={CloseIcon} alt="close_white.svg" />
    </button>
    {/* onBack && (
      <button className="action-back" onClick={onBack}>
        <img src={BackIcon} alt="back-white.svg" />
      </button>
    )*/}
    <ul className="help-content">
      <li>
        <FormattedMessage id="campaign_pay_it_forward.how_it_works_paragraph_1" />
      </li>
      <li>
        <FormattedMessage id="campaign_pay_it_forward.how_it_works_paragraph_2" />
      </li>
      <li>
        <FormattedMessage
          id="campaign_pay_it_forward.how_it_works_paragraph_3"
          values={{ referrals: <strong>{formatMessage(KeywordsMessages.referrals)}</strong> }}
        />
      </li>
      <li>
        <FormattedMessage id="campaign_pay_it_forward.how_it_works_paragraph_4" />
      </li>
      <li>
        <FormattedMessage
          id="campaign_pay_it_forward.how_it_works_paragraph_5"
          values={{ watchOut: <strong>{formatMessage(KeywordsMessages.watchOut)}</strong> }}
        />
      </li>
    </ul>
    <p className="share-with-care">
      <FormattedMessage id="campaign_pay_it_forward.share_with_care" />
    </p>
  </StyledHowItWorks>
);

HowItWorks.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  // onBack: PropTypes.func,
  isMobile: PropTypes.bool,
  bgImg: PropTypes.string,
};

export default HowItWorks;
